import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faTwitter} from '@fortawesome/free-brands-svg-icons';
//import reportWebVitals from './reportWebVitals';

class RandomQuote extends React.Component {
  render() {
    let bgColor = this.props.bgColor;

    let author = this.props.quote.author;

    let tweetLink = "https://twitter.com/intent/tweet?text=".concat(encodeURIComponent(this.props.quote.text))

    return (
      <div id="quote-box">
        <p id="text" style={{ color: bgColor }}>
          {this.props.quote.text}
        </p>
        <div id="author" style={{ color: bgColor }}>
          — {author}
        </div>
        <a
          id="tweet-quote"
          href={tweetLink}
          className="flex"
          style={{ backgroundColor: bgColor }}
        >
         <FontAwesomeIcon icon={faTwitter} />

        </a>
        <a
          id="new-quote"
          onClick={this.props.onClick}
          style={{ backgroundColor: this.props.bgColor }}
          className="flex"
          href="#"
        >
          New quote
        </a>
      </div>
    );
  }
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      quote: {
        text: "",
        author: "",
      },
      accentColor: [100, 120, 130],
    };
    this.handleClick = this.handleClick.bind(this);
  }

  randomNumber() {
    const max = 200;
    const min = 100;
    return Math.random() * (max - min) + min;
  }

  handleClick() {
    let newColor = [
      this.randomNumber(),
      this.randomNumber(),
      this.randomNumber(),
    ];
    let quoteNumber = Math.floor(Math.random() * quoteList.length);
    let newQuote = quoteList[quoteNumber];

    this.setState({
      accentColor: newColor,
      quote: newQuote,
    });
  }

  componentWillMount() {
    this.handleClick();
  }

  render() {
    let bgColor = `rgb(${this.state.accentColor[0]}, ${this.state.accentColor[1]}, ${this.state.accentColor[2]})`;

    return (
      <div className="Canvas" style={{ backgroundColor: bgColor }}>
        <RandomQuote
          quote={this.state.quote}
          bgColor={bgColor}
          onClick={() => this.handleClick()}
        />
      </div>
    );
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();

const quoteList = [
  {
    text: "It’s not who I am underneath, but what I do that defines me.",
    author: "Batman",
  },
  {
    text: "Heroes are made by the path they choose, not the powers they are graced with.",
    author: "Iron Man",
  },
  {
    text: "No man can win every battle, but no man should fall without a struggle.",
    author: "Peter Parker",
  },
  {
    text: "You’re going to make a difference. A lot of times it won’t be huge, it won’t be visible even. But it will matter just the same.",
    author: "James Gordon",
  },
  {
    text: "With great power, comes great responsibility.",
    author: "Uncle Ben",
  },
  {
    text: "I’m not a hero. I’m just a kid from Brooklyn.",
    author: "Steve Roger",
  },
  {
    text: "I'm sorry Cap. But the world needs Captain America more than they need Bucky.",
    author: "James Barnes",
  },
  {
    text: "I'm not dare devil.",
    author: "Matt Murdock",
  },
  {
    text: "You either die a hero, or you live long enough to see yourself become the villain.",
    author: "Bruce Wayne",
  },
  {
    text: "It's raining.",
    author: "The Social Network",
  },
  {
    text: "Elementary, my dear Watson.",
    author: "Sherlock Holmes",
  },
  {
    text: "Fear of a name increases fear of the thing itself.",
    author: "Albus Dumbledore",
  },
  {
    text: "It is our choices, Harry, that show what we truly are, far more than our abilities.",
    author: "Albus Dumbledore",
  },
];
